import { render, staticRenderFns } from "./FormPermissions.vue?vue&type=template&id=37eea4d2&scoped=true"
import script from "./FormPermissions.vue?vue&type=script&lang=js"
export * from "./FormPermissions.vue?vue&type=script&lang=js"
import style0 from "./FormPermissions.vue?vue&type=style&index=0&id=37eea4d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37eea4d2",
  null
  
)

export default component.exports